class QuickView {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getButton() {
    let element = this.getElement();
    return element.querySelectorAll('.js-quickView');
  }

  getClose() {
    let element = this.getElement();
    return element.querySelectorAll('.js-close');
  }

  closeQuickView() {
    let closeEl = this.getClose();

    for(let close of closeEl) {
      close.addEventListener('click', () => {
        close.closest('.js-panel').style.height = 0;
      })
    }
  }

  openQuickView() {
    let buttonEl = this.getButton();

    for(let button of buttonEl) {
      button.addEventListener('click', () => {
        button.closest('.js-article').querySelector('.js-panel').style.height = button.closest('.js-article').querySelector('.js-panel').scrollHeight + "px";;
      })
    }
  }

  setEventHandlers() {
    this.openQuickView();
    this.closeQuickView();
  }

  init() {
    this.setEventHandlers();
  }
}


const QuickViewInit = {
  init() {
    const $el = document.querySelector(".js-blog");
    if ($el) {
      new QuickView($el);
    }
  },
};


export default QuickViewInit;